<template>
  <svg
    :style="{ fill: color }"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.00001 14.4C11.5346 14.4 14.4 11.5346 14.4 7.99998C14.4 4.46535 11.5346 1.59998
        8.00001 1.59998C4.46538 1.59998 1.60001 4.46535 1.60001 7.99998C1.60001 11.5346
        4.46538 14.4 8.00001 14.4ZM10.4508 5.25544L6.80095 8.8777L5.59001 7.68346 C5.24803
        7.34619 4.69983 7.34207 4.35281 7.67415C3.9915 8.01992 3.98694 8.59574 4.34274
        8.94718L6.23655 10.8178C6.54903 11.1265 7.0519 11.1255 7.36316 10.8156L11.693
        6.50515C12.0335 6.16617 12.0396 5.61687 11.7067 5.2704C11.3658 4.91549
        10.8001 4.90875 10.4508 5.25544Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TickSvg',
  props: {
    color: {
      type: String,
      default: '#B5B5B5',
    },
  },
}
</script>
